import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaymentSettings } from '../models/PaymentMoldes';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  refreshList = new BehaviorSubject<boolean>(false);
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  GetPaymentSettings(restaurantId: number): any {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetPaymentMethodsSettings?RestaurantId=${restaurantId}`);
  }
  SavePaymentSettings(data: PaymentSettings) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResSavePaymentMethodsSettings`, data);
  }
  /*****************************
   * NFC Configuration
   */
  ResGetRestaurantNearpayNFCSetting(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetRestaurantNearpayNFCSetting?restaurantId=${restaurantId}`);
  }
  ResSetRestaurantNearpayNFCSetting(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResSetRestaurantNearpayNFCSetting`, data);
  }
  ResGetRestaurantNFCUsersList(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetRestaurantNFCUsersList?restaurantId=${restaurantId}`);
  }
}
